<app-header></app-header>
<div class="bg-image"></div>
<router-outlet></router-outlet>
